import axios from '../axios'

const postAnnouncementApi = async (courseId, payload) => {
  return await axios.post(`api/lms/courses/${courseId}/announcements`, payload)
}

export default postAnnouncementApi
